import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import HalfGaugeChart from "../../../components/custom-half-gauge-chart/HalfGaugeChart";
import RewardIcon from "../../../components/icon-components/RewardIcon";
import styles from "../styles/RewardPointsChartContainer.module.scss";

interface RewardPointsChartContainerProps {
  currentPoints: number;
  maxPoints?: number;
}

const RewardPointsChartContainer: React.FC<RewardPointsChartContainerProps> = ({
  currentPoints,
  maxPoints = 2500,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <HalfGaugeChart currentPoints={currentPoints} maxPoints={maxPoints + 1000}>
      <Box
        className={styles.container}
        data-testid="reward-points-chart-container"
      >
        <Box className={styles.rewardIcon}>
          <RewardIcon width={isMobile ? 40 : 60} height={isMobile ? 30 : 50} />
        </Box>
        <Typography variant="h1" className={styles.points}>
          {currentPoints}
        </Typography>
        <Typography variant="body2" className={styles.pointsEarned}>
          Points Earned
        </Typography>
      </Box>
    </HalfGaugeChart>
  );
};

export default RewardPointsChartContainer;
